import { customElement } from 'lit/decorators.js';
import { iconButtonStyle } from './IconButton.styles';
import { Button } from '../button/Button.component';

@customElement('lr-icon-button')
export class IconButton extends Button {
    static styles = [Button.styles, iconButtonStyle];
}

declare global {
    interface HTMLElementTagNameMap {
        'lr-icon-button': IconButton;
    }
}
